@for (toast of toastSrv.toasts(); track toast.message) {
<ngb-toast [class]="toast.className" [autohide]=" true" [delay]="toast.delay || 5000" (hidden)="toastSrv.remove(toast)">
	<div class="toast-text">
		<i class="material-icons">
			{{ toast.className == 'bg-success' ? 'done' : 'priority_high' }}
		</i>
		{{ toast.message }}
	</div>
</ngb-toast>
}